import React from "react";
import BarraEmoticons from "./emoticons/BarraEmoticons";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Preguntas from "../data/Preguntas";
import "./assets/estilos.css"


const Primera = () => {
    const { idPregunta } = useParams();
    console.log("pregunta actual ",idPregunta);

    let titulo = "";
    let img = "";
    let itemKey = 0;

    Preguntas.map((item) => {
        if (item.id == idPregunta) {
            titulo = item.text;
            img = item.imagen;
            itemKey = item.id;
        }
        return item
    });

    return (
        <>
            <Container>
                <Row>

                    <Col>
                        <div className="contenedorElemento">
                            <Card>
                                <Card.Img variant="top" src={img} />
                                <Card.Body>
                                    <Card.Title><h1>{titulo}</h1></Card.Title>
                                    <BarraEmoticons />
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                </Row>
            </Container>
        </>

    );
}

export default Primera;

